import { ITypedLambdaManifest, ILambdaManifest } from './ilambdamanifest';
import { IType } from '@augloop/schemas/dist/src/client/schemas';
import { LambdaCallback } from './ilambdaregistry';

export type inlineLambda<TInput, TOutput> = (input: TInput, workflowActions?: any, done?: LambdaCallback<TOutput>) => TOutput | void;

class FunctionReviver {
    private readonly functionName: string;
    private readonly debuggable: boolean;
    private readonly dependencyArguments: IterableIterator<string>;

    public constructor(functionName?: string, dependencyArguments?: IterableIterator<string>, debuggable?: boolean) {
        this.functionName = functionName;
        this.debuggable = debuggable;
        this.dependencyArguments = dependencyArguments;
    }

    public reviver = (_key: unknown, value: string | unknown): string | unknown => {
        if (typeof value === 'string') {
            // match[0] would be the whole function
            // match[1] would have all the parameters list
            // match[2] would have the function body as it is
            const rfunc = /function[^\(]*\(([^\)]*)\)\s*{([\w\W]*?)}$/;
            const rArrowFunc = /\(([^\)]*)\)\s*=>\s*{([\w\W]*?)}$/;
            const match = value.match(rfunc) || value.match(rArrowFunc);

            if (match) {
                let args = match[1].split(',')
                    .map((arg) => arg.replace(/\s+/, ''));
                let body = this.functionName ? match[2].concat(`//# sourceURL=${this.functionName}.js`) : match[2];
                if (this.debuggable) {
                    body = 'debugger;'.concat(body);
                }

                if (this.dependencyArguments) {
                    args = args.concat(Array.from(this.dependencyArguments));
                }

                return Function(...args, body); // eslint-disable-line no-new-func
            }
        }
        return value;
    }
}

export const functionReplacer = (_key: unknown, value: unknown): unknown => {
    if (typeof value === 'function') {
        return value.toString();
    }
    return value;
};

export const functionReviver = (functionName?: string, dependencyArguments: IterableIterator<string> = null, debuggable: boolean = false): (_key: unknown, value: string | unknown) => string | unknown => {
    const funcReviver = new FunctionReviver(functionName, dependencyArguments, debuggable);

    return funcReviver.reviver;
};

export interface ITypedLambda<TIn, TOut> extends ITypedLambdaManifest<TIn, TOut>, ILambda {
}

export interface ILambda extends ILambdaManifest {
    lambda: Function;
    passInputSchema?: boolean;
    passOutputSchema?: boolean;
}

export const getTypesFromLambdas = (lambdas: ILambda[]): IType[] => {
    const types: IType[] = [];
    for (const lambda of lambdas) {
        if (lambda.inputSchema) {
            types.push(lambda.inputSchema);
        }

        if (lambda.outputSchema) {
            types.push(lambda.outputSchema);
        }

        if (lambda.configSchema) {
            types.push(lambda.configSchema);
        }
    }

    return types;
};
